import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import "../../../../assets/css/patient/patientlayouts/layoutpages/Dashboard.css";

const Dashboard = () => {
  const { user, baseUrl, logout } = useContext(AppContext);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      const token = localStorage.getItem("patient_token");

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${baseUrl}/Patient/Dashboard/stats`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data.success) {
          setStats(res.data.data);
        } else {
          setError("Could not load dashboard stats");
        }
      } catch (err) {
        console.log("Dashboard stats fetch error:", err);

        if (err?.response?.status === 401) {
          logout(); // token expired/invalid — patient ko logout kardo
        } else {
          setError("Something went wrong while loading your dashboard");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [baseUrl, logout]);

  return (
    <div className="dash-overview-container">
      <div className="dash-overview-header">
        <div>
          <h2>Welcome back, {user?.name?.split(" ")[0] || "Patient"} 👋</h2>
          <p>Here's what's happening with your therapy journey</p>
        </div>
      </div>

      <div className="dash-stats-grid">
        <div className="dash-stat-card">
          <span className="dash-stat-number">
            {loading ? "…" : stats?.upcoming_sessions ?? 0}
          </span>
          <span className="dash-stat-label">Upcoming Sessions</span>
        </div>
        <div className="dash-stat-card">
          <span className="dash-stat-number">
            {loading ? "…" : stats?.new_notifications ?? 0}
          </span>
          <span className="dash-stat-label">New Notifications</span>
        </div>
        <div className="dash-stat-card">
          <span className="dash-stat-number">
            {loading ? "…" : stats?.ai_sessions_this_month ?? 0}
          </span>
          <span className="dash-stat-label">AI Sessions This Month</span>
        </div>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="dash-section">
        <h3>Quick Actions</h3>
        <div className="dash-actions-grid">
          <Link to="/patientdashboard/myappointments" className="dash-action-btn">
            Book / View Appointments
          </Link>
          <Link to="/patientdashboard/supportticket" className="dash-action-btn">
            Raise a Support Ticket
          </Link>
          <Link to="/patientdashboard/mysettings" className="dash-action-btn">
            Update Settings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;